import React from 'react';
import { ShareableQuote } from './ShareableQuote';

export const QuoteBlock = ({ quote }) => {
  return (
    <div 
      data-testid="quote-block"
      className="my-10 py-6 px-8 border-l-2 border-sage/50 bg-sage/5 rounded-r-lg animate-fade-in"
    >
      <div className="flex items-start justify-between gap-4">
        <p className="font-heading text-lg md:text-xl text-charcoal/80 italic leading-relaxed flex-1">
          "{quote}"
        </p>
        <ShareableQuote quote={quote} type="quote" />
      </div>
    </div>
  );
};
